import React from 'react';
import {Button, Card, Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {Progress} from '../Progress';
import {Counter} from '../Counter';
import {useCountdown} from '../../../hooks/useCountdown/index';
import {TokenCardProps} from './types';

const {description} = translations['pt-br'].privateFlow.token;
const {goToHome} = translations['pt-br'].commons;

export function TokenCard({tokenNumber, remainingTimeInSeconds, handleBack}: TokenCardProps) {
	const {isExpired} = useCountdown(remainingTimeInSeconds);

	return (
		<Card elevation={0} sx={{p: 3}}>
			<Typography>{description}</Typography>
			<Stack gap={2}>
				<Progress
					tokenNumber={tokenNumber}
					initialValueInSeconds={remainingTimeInSeconds}
				/>

				<Counter initialValueInSeconds={remainingTimeInSeconds} />

				{isExpired ? (
					<Button
						variant="contained"
						size="large"
						onClick={handleBack}
						sx={{mx: 'auto', width: 'max-content'}}>
						{goToHome}
					</Button>
				) : null}
			</Stack>
		</Card>
	);
}
